module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-1-medium-51eb0e7406f497aab38e514aed1a2a80.jpg";